const SPEAKER_ROLE = /^speaker(?:\s*#\s*(\d+))?$/i;
const EVALUATOR_ROLE = /^evaluator(?:\s*#\s*(\d+))?$/i;

function roleNumber(name, pattern) {
  const match = pattern.exec(String(name || '').trim());
  return match ? Number(match[1] || 1) : null;
}

function userIds(user) {
  return [user?._id, user?.tmAuthUserId, user?.localUserId]
    .map(value => String(value || '').trim())
    .filter(Boolean);
}

// "Speaker" pairs with "Evaluator", "Speaker #2" with "Evaluator #2", and so on.
export function isAssignedSpeechEvaluator({ prompt, items = [], assignments = [], user }) {
  const currentIds = userIds(user);
  if (!prompt?.agendaItemId || !currentIds.length) return false;
  const speechItem = items.find(item => String(item?.agendaItemId) === String(prompt.agendaItemId));
  const speakerNumber = roleNumber(speechItem?.meetingRole?.name, SPEAKER_ROLE);
  if (!speakerNumber) return false;
  return (Array.isArray(assignments) ? assignments : []).some(assignment => (
    roleNumber(assignment?.role?.name, EVALUATOR_ROLE) === speakerNumber
    && userIds(assignment?.user).some(id => currentIds.includes(id))
  ));
}
